// extracted by mini-css-extract-plugin
export default {"successPageContianer":"SuccessfulPayment_successPageContianer__nTkIR","iconWrapper":"SuccessfulPayment_iconWrapper__kYocf"};